// src/routes/jukebox.tsx
import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export interface JukeboxSearch {
  /**
   * trueの場合、ヘッダー・サイドメニュー等のアプリ枠を付けず
   * ジュークボックス単独で表示する(PC版の別ウィンドウ/フォールバック遷移用。
   * __root.tsx のレイアウト分岐が参照する)。
   */
  standalone?: boolean;
}

export const Route = createFileRoute("/jukebox")({
  component: lazyRouteComponent(
    () => import("@/pages/JukeboxPage"),
    "JukeboxPage",
  ),
  validateSearch: (search: Record<string, unknown>): JukeboxSearch => {
    const standalone = search.standalone;
    // URL手打ちも考慮し、"1"/1/true のいずれも受け付ける
    return standalone === true || standalone === 1 || standalone === "1"
      ? { standalone: true }
      : {};
  },
});
